<template>
  <div class="row">
    <div class="col-12">
      <div class="section-title my-2">
        <h3>Kalkulačka</h3>
      </div>
    </div>
    <div class="col-md-8">
      <div class="calc-row flex-column flex-sm-row">
        <div class="calc-slider">
          <div class="icon-title lh-1">
            <img
                src="data:image/png;base64,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"
                class="img-fluid float-start" width="40">
            Investovaná částka
            <br>
            <small class="text-muted" style="font-size: 0.75rem">(*maximální výše investice není omezena)</small>
          </div>
          <div class="calc-slider-wrapper">
            <vue-slider :min="amount.min" :max="amount.max"
                        :interval="amount.step"
                        :marks="amountMarks"
                        v-model="amount.value"
                        :tooltip="'active'"
                        :tooltip-formatter="filterAmount(amount.value)"
                        style="padding: 0 1rem;"
            >
              <template v-slot:dot="{ value, focus }">
                <div :class="['moving-dot', { focus }]"></div>
              </template>
            </vue-slider>
          </div>
        </div>
        <div class="calc-buttons flex-nowrap flex-sm-wrap mt-3 mt-sm-0">
          <h5 class="icon-value fw-bold">
            {{ filterAmount(amount.value) }}
          </h5>
          <button class="icon-circle btn-warning border-0" @click="valMinus('amount')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash"
                 viewBox="0 0 16 16">
              <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
            </svg>
          </button>
          <button class="icon-circle btn-success border-0" @click="valPlus('amount')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus"
                 viewBox="0 0 16 16">
              <path
                  d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            </svg>
          </button>
        </div>
      </div>
      <div class="calc-row flex-column flex-sm-row">
        <div class="calc-slider">
          <div class="icon-title">
            <img
                src="data:image/png;base64,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"
                class="img-fluid" width="40">
            Délka investice
          </div>
          <div class="calc-slider-wrapper">
            <vue-slider :min="period.min" :max="period.max"
                        :interval="period.step"
                        :marks="periodMarks"
                        v-model="period.value"
                        :tooltip="'active'"
                        :tooltip-formatter="filterPeriod(period.value)"
                        style="padding: 0 1rem;"

            >

              <template v-slot:dot="{ value, focus }">
                <div :class="['moving-dot', { focus }]"></div>
              </template>
            </vue-slider>
          </div>
        </div>
        <div class="calc-buttons calc-buttons flex-nowrap flex-sm-wrap mt-3 mt-sm-0">
          <h5 class="icon-value fw-bold">
            {{ filterPeriod(period.value) }}
          </h5>
          <button class="icon-circle btn-warning border-0" @click="valMinus('period')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                 class="bi bi-caret-left-fill" viewBox="0 0 16 16">
              <path
                  d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
            </svg>
          </button>
          <button class="icon-circle btn-success border-0" @click="valPlus('period')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                 class="bi bi-caret-right-fill" viewBox="0 0 16 16">
              <path
                  d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
            </svg>
          </button>
        </div>
      </div>
      <!--
      <Chart style="height: 200px"
             :chart-data="chartDataComputed"
             :options="chartOptions"
      />
      -->
    </div>
    <div class="col-md-4 border-left">
      <table class="table table-bordered text-center">
        <tr>
          <td>
            Investovaná částka
          </td>
          <td>
            {{ filterAmount(amount.value) }}
          </td>
        </tr>
        <tr>
          <td>
            Délka investice
          </td>
          <td>
            {{ filterPeriod(period.value) }}
          </td>
        </tr>
        <tr>
          <td>
            <strong>Výnos p.a.</strong>
          </td>
          <td>
            <strong>{{ this.yield }} % p.a.</strong>
          </td>
        </tr>
        <tr>
          <td>Výnos za 1 rok</td>
          <td> {{ filterAmount((amount.value * (yield / 100)))                   }}</td>
        </tr>
        <tr>
          <td>Výnos za {{ filterPeriod(period.value) }}</td>
          <td> {{ filterAmount(amount.value * (yield / 100) * (period.value / 12)) }}</td>
        </tr>
        <tr class="table-success">
          <td>
            <div><strong>Celkový výnos</strong></div>
          </td>
          <td>
            <div>
              <strong> {{ filterAmount(amount.value + (amount.value * (yield / 100)) * (period.value / 12)) }}</strong>
            </div>
          </td>
        </tr>
      </table>
      <div class="text-center">
        <button class="btn btn-success btn-block" data-bs-toggle="modal" data-bs-target="#contact-modal">
          Chci začít investovat
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "./Chart"
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  name: "Calculator",
  components: {
    Chart,
    VueSlider,
  },
  mounted() { // load data from table
    const rows = document.querySelectorAll('#products tbody tr');
    rows.forEach((row) => {
      row.addEventListener('click', (e) => {
            let target = event.target; //tbody > tr > td.class('xxxx')
            target = target.parentElement // tbody > tr

            this.yield = parseFloat(target.getElementsByClassName('yield')[0].textContent);

            let minimalDeposit = target.getElementsByClassName('minimal_deposit')[0].textContent;
            minimalDeposit = parseInt(minimalDeposit.replace(/\D/g, ''));
            this.amount.min = minimalDeposit > 1000 ? minimalDeposit : 1000;

            let nominalValue = target.getElementsByClassName('nominal_value');
            if (nominalValue.length) {
              nominalValue = nominalValue[0].textContent;
              nominalValue = parseInt(nominalValue.replace(/\D/g, ''));
              nominalValue = nominalValue > 1000 ? nominalValue : 1000 // take nominal value
            } else {
              nominalValue = minimalDeposit > 1000 ? minimalDeposit : 1000; // take deposit
            }

            if (minimalDeposit > nominalValue) {
              this.amount.max = this.amount.min * this.amountStepsCount;
              this.amount.value = this.amount.min * this.defaultStepsValue;
              this.amount.step = nominalValue;
            } else {
              this.amount.max = this.amount.min * this.amountStepsCount;
              this.amount.value = this.amount.min * this.defaultStepsValue;
              this.amount.step = this.amount.min;
            }

            let timeHorizon = parseInt(target.getElementsByClassName('time_horizon')[0].getAttribute('data-time-horizon'));
            if (!timeHorizon)
              timeHorizon = 6;

            let timeCalcLimit = parseInt(target.getElementsByClassName('time_horizon')[0].getAttribute('data-time-calc-limit'));
            if (!timeCalcLimit)
              timeCalcLimit = false;

            if (timeCalcLimit) { // pokud je nastaven jednorázový produkt

              if (timeHorizon % 12 === 0) {
                const steps = timeHorizon / 12;
                this.period.min = 12;
                this.period.step = steps;
                this.periodStepsCount = steps;
              }

              this.period.value = timeHorizon
              this.period.max = timeHorizon;

            } else {

              if (timeHorizon <= 6) {
                this.period.max = timeHorizon * this.periodStepsCount * 4;
              } else if (timeHorizon <= 12) {
                this.period.max = timeHorizon * this.periodStepsCount * 1;
              } else {
                this.period.max = timeHorizon * this.periodStepsCount;
              }
              this.period.min = timeHorizon;
              this.period.step = timeHorizon;
              this.period.value = timeHorizon * this.defaultStepsValue;
            }
          }
      )
    })
    //reset calc
    rows[0].click();
  },
  data: () => ({
    amountStepsCount: 10,
    periodStepsCount: 5,
    defaultStepsValue: 2,
    yield: 0,
    amount: {
      value: 1,
      step: 10000,
      min: 0,
      max: 5000000,
    },
    period: {
      value: 1,
      step: 1,
      min: 1,
      max: 120,
    },

    /* chartOptions: {
       legend: {
         display: false
       },
       responsive: true,
       maintainAspectRatio: false,
       responsiveAnimationDuration: 5,
       showLines: true,
       tooltips: {
         mode: 'label',
         bodySpacing: 10,
         cornerRadius: 0,
         titleMarginBottom: 15
       },
       scales: {
         yAxes: [{
           ticks: {
             //min: 50000,
             //max: 1000000,
             //stepSize: 100000,
             maxTicksLimit: 8,
             reverse: false,
             beginAtZero: true,
             userCallback: function (value) {
               value = value.toString();
               value = value.split(/(?=(?:...)*$)/);
               value = value.join(' ');
               return value + ' Kč';
             }
           },
           scaleLabel: {
             display: true,
             labelString: 'Investovaná částka'
           }
         },]
       },
       plugins: {
         datalabels: {
           anchor: "end",
           align: "top",
           //color: "white",
           textAlign: "center",
           font: {
             size: 14,
             weight: 'bold'
           },
           display: function (context) {
             return context.dataIndex % 2; // display labels with an odd index
           },
           formatter: function (value) {
             if (!value) return '';
             value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "\xa0");
             return value + '\xa0Kč';
           }
         }
       }
     }*/
  }),
  methods: {
    valPlus: function (valName) {
      const data = eval('this.' + valName);
      if (data.max === null || (data.value < data.max)) {
        const sliderStep = data.max / eval('this.' + valName + 'StepsCount');
        let step = data.step;
        if (data.value >= sliderStep && data.step < sliderStep) {
          step = sliderStep;
        }
        data.value = data.value + step;
        eval('this.' + valName + '.value=data.value;');
      }
    },
    valMinus: function (valName) {
      const data = eval('this.' + valName);
      if (data.min === null || (data.value) > data.min) {
        const sliderStep = data.max / eval('this.' + valName + 'StepsCount');
        let step = data.step;
        if (data.value > sliderStep && data.step < sliderStep) {
          step = sliderStep;
        }
        data.value = data.min <= (data.value - step) ? (data.value - step) : data.min;
        eval('this.' + valName + '.value=data.value;');
      }
    },

    filterAmount(value) {
      if (!value) return '';
      value = Math.round(value);
      value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "\xa0");
      return value + 'Kč'; //'\xa0Kč'
    },
    filterPeriod(value) {
      var year = value / 12;
      var yearFloor = Math.floor(year);
      var diff = year - yearFloor;
      var quartal = '';
      if (Number.isInteger(year)) {
        quartal = '';
      } else if (Number.isInteger(diff / 0.75)) {
        quartal = '¾';
      } else if (Number.isInteger(diff / 0.5)) {
        quartal = '½';
      } else if (Number.isInteger(diff / 0.25)) {
        quartal = '¼';
      }
      var strTime = '';
      if (year <= 1) {
        strTime = 'rok';
      } else if (year < 5) {
        strTime = 'roky';
      } else {
        strTime = 'let';
      }
      return (yearFloor ? yearFloor : '') + quartal + '\xa0' + strTime;
    }
  }
  ,
  computed: {
    periodMarks() {
      const result = {};
      const period = this.period;
      let step = this.period.step;

      if (period.max / period.step >= this.periodStepsCount) {
        step = period.max / this.periodStepsCount;
      }

      // Step 1 - is minimal value
      result[this.period.min] = this.filterPeriod(this.period.min);
      // Step 2,3,4....
      for (let i = step;
           i <= period.max;
           i += step) {
        //  if (amount.min >= i)
        result[i] = this.filterPeriod(i);
      }

      return result;
    }
    ,
    amountMarks() {
      const result = {};
      const amount = this.amount;
      let step = this.amount.step;

      if (amount.max / amount.step >= this.amountStepsCount) {
        step = amount.max / this.amountStepsCount;
      }
      // Step 1 - is minimal value
      if(window.innerWidth < 992){
        result[this.amount.min] = (this.amount.min /1000) + 'tis.';
      }else{
        result[this.amount.min] = this.filterAmount(this.amount.min);
      }

      // Step 2,3,4....
      for (let i = step;
           i <= amount.max;
           i += step) {
        //Step 1 skip
        if (amount.min !== i)
          if(window.innerWidth < 992){
            result[i] =  (i /1000) + 'tis.';
          }else{
            result[i] = this.filterAmount(i);
          }
      }
      return result;
    }
    ,
    /*
        chartDataComputed: function () {
          var period = this.period.value;
          period = (period / 12);
          var step = this.amount.value * (this.yield / 100);
          var amount = this.amount.value;
          var data = [];
          var labels = [];
          for (var i = 0; i < period; i++) {
            amount = amount + step;
            data.push(amount);
            labels.push((i + 1) + '. rok');
          }
          return {
            labels: labels,
            datasets: [{
              data: data,
              label: '',
              backgroundColor: '#87CEFA'
            }]
          };
        }
        ,
        chartOptionsComputed: function () {
          var options = this.chartOptions;
          var breakPoints = [100, 500, 1000, 5000, 10000]; // in breakpoint* 1000
          var breakpointValue = 0;
          //var amount = this.amount.value;
          breakpointValue = breakPoints.find(num => (num * 1000) > this.amount.value);
          console.log(breakpointValue);
          options.scales.yAxes[0].ticks.max = breakpointValue * 1000;
          console.log(options.scales.yAxes[0].ticks);
          return options;
        }*/
  }
}
</script>
<style>
/* když má více než 8 prvků*/
.vue-slider-marks:has(> :nth-child(8)) .vue-slider-mark:nth-child(2n) .vue-slider-mark-label {
  padding-top: 1.2rem;
}

.vue-slider-mark:nth-child(2n+1) .vue-slider-mark-label {
  padding-bottom: 1.2rem;
}

.vue-slider-mark-label {
  cursor: pointer;
}

/*.vue-slider-mark:nth-child(2n) .vue-slider-mark-label{
  padding-top: 1.2rem;
}*/
</style>
<style scoped lang="scss">
.result_title {

}

.result_value {
  font-weight: bold;
}

.border-left {
  border-left: 1px solid rgb(238, 238, 238);
}

.calc-row {
  display: flex;
  padding-bottom: 1rem;
}

.calc-slider {
  display: inline-block;
  width: 100%;
}

.calc-slider-wrapper {
  margin: 1rem 1rem 3rem;
}

.calc-buttons {
  text-align: center;
  min-width: 150px;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  align-items: center;

  .icon-value {
    width: 100%;
  }
}

.moving-dot {
  width: 27px;
  height: 27px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0.5px 0.5px 2px #555;
  padding: 2px;
  /*transition: all .3s;*/
  cursor: pointer;
  position: absolute;
  top: -5px;
  left: -5px;

  &:before {
    content: '';
    background: url('swipe.png');
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;
    width: 22px;
    height: 22px;
  }

  &:hover {
    animation-name: movingDot;
    animation-duration: 1s;
  }

  @keyframes movingDot {
    0% {
      transform: rotateZ(-30deg);
    }
    25% {
      transform: rotateZ(+30deg);
    }
    50% {
      transform: rotateZ(-15deg);
    }
    75% {
      transform: rotateZ(+15deg);
    }
    100% {
      transform: rotateZ(0deg);
    }
  }
}
</style>